export default __webpack_public_path__ + "static/media/PlasmaTorchImg.29cc32b7.jpg";